// extracted by mini-css-extract-plugin
export default {"singleselect":"singleselect--38b70381","singleSelectBase":"singleSelectBase--2d0f5dfa"};